import { State } from '../configure-store';

export const getActiveModalName = (state: State) =>
  state.activeModal.modalName;

export const getActiveModalParams = (state: State) =>
  state.activeModal.params;
